<template>
  <div
    :id="'page' + index"
    :refs="'page' + index"
    :class="{ _page: true, _show: show }"
    @click="$emit('click', index)"
    @touchstart="touchstart"
    @touchmove="mousemove"
    @scroll="scroll"
  >
    <slot></slot>
  </div>
</template>

<script>
export default {
  name: "page",
  componentName: "page",
  inject: ["pagesSup"],
  props: {
    index: {
      type: String,
    },
    slideDownMax: {
      type: Number,
      default: 50,
    },
    bottomMax: {
      type: Number,
      default: 0,
    },
  },
  data() {
    return {
      pages: [],
      show: false,
      clientY: 0,
      bottomMaxBase: 0,
    };
  },
  mounted() {
    let _this = this;
    _this.$store.dispatch("esPageAdd", _this);
    if (_this.index == _this.pagesSup.index) {
      _this.showPage();
    }
    if (_this.bottomMax == 0) {
      _this.bottomMaxBase = window.innerHeight;
    } else {
      _this.bottomMaxBase = _this.bottomMax;
    }
  },
  beforeDestroy() {
    this.$store.dispatch("esPageRemove", this);
  },
  methods: {
    hidePage() {
      let _this = this;
      _this.show = false;
    },
    showPage() {
      this.show = true;
    },
    touchstart(event) {
      this.clientY = event.touches[0].clientY;
    },
    mousemove(event) {
      // 判断上滑 下拉
      if (this.clientY - event.changedTouches[0].clientY > this.slideDownMax) {
        this.$emit("slideUp", this.index);
      } else if (
        event.changedTouches[0].clientY - this.clientY >
        this.slideDownMax
      ) {
        this.$emit("slideDown", this.index);
      }
    },
    scroll(e) {
      let _this = this;
      if (
        e.srcElement.scrollTop + e.srcElement.offsetHeight >=
        _this.bottomMaxBase - 5
      ) {
        this.$emit("bottomUp", this.index);
      }
    },
  },
};
</script>

<style lang="scss">
._page {
  height: 100%;
  width: 100%;
  display: none;
  overflow: hidden;
}
</style>